import { render, staticRenderFns } from "./RemarkList.vue?vue&type=template&id=2e23ab68&scoped=true"
import script from "./RemarkList.vue?vue&type=script&lang=js"
export * from "./RemarkList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23ab68",
  null
  
)

export default component.exports